import { render, staticRenderFns } from "./tambahanggaran.vue?vue&type=template&id=5e4b2580&"
import script from "./tambahanggaran.vue?vue&type=script&lang=js&"
export * from "./tambahanggaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports